import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';
import { AppState } from './types';
import { RootState } from '../types';

const state: AppState = {
  isLoading: false,
  blockedUI: false,
  signedOut: false,
  menuOpen: false,
};

const mutations: MutationTree<AppState> = {
  SET_LOADING(state: AppState, loadingState:Boolean) {
    state.isLoading = loadingState;
  },
  
  SET_BLOCK_UI(state: AppState) {
    state.blockedUI = true;
  },

  SET_SIGNED_OUT(state: AppState, signedOut:boolean) {
    state.signedOut = signedOut;
  },

  TOGGLE_MENU(state: AppState) {
    state.menuOpen = !state.menuOpen;
  },
};

const getters: GetterTree<AppState, RootState> = {
  isLoading: (state: AppState) => state.isLoading,
  isBlockedUI: (state: AppState) => state.blockedUI,
  signedOut: (state: AppState) => state.signedOut,
  menuOpen: (state: AppState) => state.menuOpen,
};

const actions: ActionTree<AppState, RootState> = {

  startLoader({ commit }: { commit: Function}) {
    commit('SET_LOADING', true);
  },

  stopLoader({ commit }: { commit: Function }) {
    commit('SET_LOADING', false);
  },

  blockUI({ commit }: { commit: Function, }) {
    commit('SET_BLOCK_UI', true);
  },

  signedOut({ commit }: { commit: Function, }) {
    commit('SET_SIGNED_OUT', true);
  },

  unblockUI({ commit }: { commit: Function, }) {
    commit('SET_BLOCK_UI', false);
  },

  toggleMenu({ commit }: { commit: Function, }) {
    commit('TOGGLE_MENU');
  },
};

export const appState: Module<AppState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
